export const UPDATE_USER_AUTHORIZATION = 'UPDATE_USER_AUTHORIZATION';
